var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"flat pa-0 ma-0",attrs:{"flat":"","fluid":""}},[_c('Calendar',{ref:"calendar",style:(`height:${_vm.height}`),attrs:{"view":_vm.view,"events":_vm.getEvents,"theme":_vm.getCalendarTheme,"week":_vm.options && _vm.options.week,"isReadOnly":""}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }